import AvatarPhoto from "./avatar-photo";

export default AvatarPhoto;